// Core
import { useParams } from "next/navigation";
import useSWR from "swr";
import HttpStatusCode from "http-status-codes";

// Definitions
import type { GameType } from "../types";
import type { HttpResponseAxiosDataType, HttpResponseAxiosErrorType } from "@/types/http";

// Utils
import { gamesApi } from "../service";
import { gamesKeys } from "../apiKeys";
import { log } from "@/utils/browser-logger";

type GameSlugType = [string, string];

type UseGameFetchType = {
  loadingGameFetch: boolean;
  game: GameType | null;
};

const fetcher = (slug: GameSlugType) => () => gamesApi.fetchOneGame({ params: { slug } });

export const useGameFetch = (): UseGameFetchType => {
  const { slug } = useParams<{ slug: GameSlugType }>();
  const { data, isLoading } = useSWR<
    HttpResponseAxiosDataType<GameType>,
    HttpResponseAxiosErrorType
  >([gamesKeys.games, slug], fetcher(slug), {
    onError: (err: HttpResponseAxiosErrorType) => {
      try {
        const status = err.response.status;
        const isError400 = status >= HttpStatusCode.BAD_REQUEST;
        const isError500 = status && status >= HttpStatusCode.INTERNAL_SERVER_ERROR;
        if (isError400 || isError500) {
          log.crucial(err.message);
        }
      } catch (e) {
        log.crucial(err.message);
      }
    },
  });
  return {
    loadingGameFetch: isLoading,
    game: data?.data || null,
  };
};
